import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useAuth } from './AuthContext';

const MessagesContext = createContext();

export const MessagesProvider = ({ children }) => {
    const { user } = useAuth();
    const [localCollapsed, setLocalCollapsed] = useState([]);
    const [cachedMessages, setCachedMessages] = useState([]);

    // Synchroniser avec user.collapsedMessages au montage et aux changements
    useEffect(() => {
        if (user?.collapsedMessages) {
            setLocalCollapsed(user.collapsedMessages);
        }
    }, [user?.collapsedMessages]);

    const isCollapsed = useCallback((messageId) => {
        return localCollapsed.includes(messageId);
    }, [localCollapsed]);

    const toggleCollapsed = useCallback((messageId) => {
        setLocalCollapsed(prev => {
            if (prev.includes(messageId)) {
                return prev.filter(id => id !== messageId);
            } else {
                return [...prev, messageId];
            }
        });
    }, []);

    const updateCachedMessages = useCallback((messages) => {
        setCachedMessages(messages);
    }, []);

    const getMessageById = useCallback((messageId) => {
        return cachedMessages.find(m => m._id === messageId);
    }, [cachedMessages]);

    return (
        <MessagesContext.Provider value={{
            isCollapsed,
            toggleCollapsed,
            cachedMessages,           // Exposer le cache
            updateCachedMessages,     // Exposer la fonction de mise à jour
            getMessageById,          // Exposer la fonction de recherche
        }}>
            {children}
        </MessagesContext.Provider>
    );
};

export const useMessages = () => {
    const context = useContext(MessagesContext);
    if (!context) {
        throw new Error('useMessages must be used within MessagesProvider');
    }
    return context;
};